export const GO_TO_NEXT_KEY = "goToNextAutomatically";
export const TEST_RUN_SHOW_DIFF_KEY = "testRunShowDiff";
